import type { FeaturedProject, GalleryProject } from '../types/content'

const images = {
  kitchenBefore: 'https://cdn.magicpatterns.com/uploads/nGVvsKrCtNt3sahZg2L74t/Antes_cocina.jpg',
  kitchenAfter: 'https://cdn.magicpatterns.com/uploads/qWbsV2rDWz3Ks637Zaxvkw/Despues_cocina.jpg',
  exterior: 'https://cdn.magicpatterns.com/uploads/n2p2cNV2SacYHyKKJAHCfV/Pintura_casa_3.jpg',
  commercial: 'https://cdn.magicpatterns.com/uploads/dMRi6Kungcez39ZAkavnKW/Foto_pintura_ascensor.jpg',
  drywallBefore:
    'https://cdn.magicpatterns.com/patterns/generated-images/99d77a28-5ba5-405a-8fa8-1e0ed7991dcc.jpg',
  drywallAfter:
    'https://cdn.magicpatterns.com/patterns/generated-images/259e578b-ab34-4861-bade-65d61e9ea027.jpg',
  flooring:
    'https://cdn.magicpatterns.com/patterns/generated-images/17bb2718-2ccf-442b-b8a8-cb23d8b4b13b.jpg',
  bathroom:
    'https://cdn.magicpatterns.com/patterns/generated-images/45e760f3-3cd8-43a0-852a-85e5ad97ea2d.jpg',
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/9706ae85-d8e0-46e9-bd91-96cbb6f97bbf.jpg',
}

export const heroImage = images.hero

export const heroBanner =
  'https://cdn.magicpatterns.com/uploads/gbZBMPgJqsKBzxHJ3CiRDB/banner_Ms.png'

export const galleryProjects: GalleryProject[] = [
  {
    id: 'kitchen-everglade',
    caption: {
      en: 'Kitchen Cabinet Painting & Remodel — Everglade Rd, Dallas',
      es: 'Pintura de Gabinetes y Remodelación de Cocina — Everglade Rd, Dallas',
    },
    category: { en: 'Remodeling', es: 'Remodelación' },
    before: images.kitchenBefore,
    after: images.kitchenAfter,
  },
  {
    id: 'drywall-repair',
    caption: {
      en: 'Drywall Installation & Finishing — Garland, TX',
      es: 'Instalación y Acabado de Drywall — Garland, TX',
    },
    category: { en: 'Drywall', es: 'Drywall' },
    before: images.drywallBefore,
    after: images.drywallAfter,
  },
  {
    id: 'exterior-southerland',
    caption: {
      en: 'Full Exterior Repaint — Southerland Dr, Denton County',
      es: 'Pintura Exterior Completa — Southerland Dr, Condado de Denton',
    },
    category: { en: 'Exterior Painting', es: 'Pintura Exterior' },
    after: images.exterior,
  },
  {
    id: 'lvp-living',
    caption: {
      en: 'LVP Flooring Installation — Plano, TX',
      es: 'Instalación de Piso LVP — Plano, TX',
    },
    category: { en: 'Flooring', es: 'Pisos' },
    after: images.flooring,
  },
  {
    id: 'bathroom-remodel',
    caption: {
      en: 'Bathroom Remodel & Repaint — Irving, TX',
      es: 'Remodelación y Pintura de Baño — Irving, TX',
    },
    category: { en: 'Remodeling', es: 'Remodelación' },
    after: images.bathroom,
  },
  {
    id: 'commercial-hallway',
    caption: {
      en: 'Commercial Hallway & Elevator Painting — Dallas, TX',
      es: 'Pintura de Pasillo y Ascensor Comercial — Dallas, TX',
    },
    category: { en: 'Interior Painting', es: 'Pintura Interior' },
    after: images.commercial,
  },
]

export const featuredProjects: FeaturedProject[] = [
  {
    id: 'featured-kitchen',
    title: {
      en: 'Galley Kitchen Transformation — Everglade Rd, Dallas',
      es: 'Transformación de Cocina — Everglade Rd, Dallas',
    },
    summary: {
      en: 'A dated galley kitchen with yellowed cabinets and worn flooring. We masked and protected every surface, sprayed the cabinetry in a durable white finish, repainted walls and trim, and installed wood-look LVP through the adjoining hallway.',
      es: 'Una cocina anticuada con gabinetes amarillentos y piso desgastado. Protegimos cada superficie, pintamos los gabinetes con acabado blanco durable, repintamos paredes y molduras, e instalamos piso LVP tipo madera hasta el pasillo.',
    },
    scope: {
      en: 'Cabinet refinishing, walls, ceiling, trim, LVP flooring',
      es: 'Gabinetes, paredes, techo, molduras y piso LVP',
    },
    duration: { en: '6 working days', es: '6 días hábiles' },
    result: {
      en: 'A bright, modern kitchen without the cost of new cabinetry.',
      es: 'Una cocina luminosa y moderna sin el costo de gabinetes nuevos.',
    },
    before: images.kitchenBefore,
    after: images.kitchenAfter,
  },
  {
    id: 'featured-drywall',
    title: {
      en: 'Water-Damaged Drywall Rebuild — Garland, TX',
      es: 'Reconstrucción de Drywall Dañado por Agua — Garland, TX',
    },
    summary: {
      en: 'A burst supply line left a large open section of wall. We cut back to sound material, replaced the sheet, taped and floated the seams, matched the existing orange-peel texture, then primed and painted the full wall for a seamless blend.',
      es: 'Una tubería rota dejó una sección abierta de pared. Cortamos hasta material sano, reemplazamos la lámina, aplicamos cinta y masilla, igualamos la textura orange-peel existente y pintamos la pared completa para un acabado sin costuras.',
    },
    scope: {
      en: 'Demo, sheet replacement, tape & float, texture match, paint',
      es: 'Demolición, lámina nueva, cinta y masilla, textura, pintura',
    },
    duration: { en: '3 working days', es: '3 días hábiles' },
    result: {
      en: 'The repair is invisible — you cannot tell where the damage was.',
      es: 'La reparación es invisible — no se nota dónde estaba el daño.',
    },
    before: images.drywallBefore,
    after: images.drywallAfter,
  },
]
